export const environment = {
  production: false,
  name: "qa",
  appMetaRef:"89D2D1C4299AFD252AD6C3F9CE23290FF7ACE11A3EB9D60DBB94894A7F598311"
};
